import React, { useEffect, useState } from "react";
import {
  abhaCartDownloadServices,
  abhaCartDownloadServicesVerification,
  createAbhaUserServices,
  UpdateAbhaUserServices,
} from "../../services";
import "./abhacard.css";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setGlobalCurrentStep } from "../../redux/slices/abhaSlice";
import formBgImg from "../../assets/image/Group 2147206200.png";
import about from "../../assets/image/about_nha_pg_logo.png";

const AbhaCardUI = ({ downloadFlowToken, inputType }) => {
  // ── All state & logic — unchanged ──
  const [abhacarddata, setAbhacarddata] = useState("");
  const [xToken, setXToken] = useState(null);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const cardSelectedInMobileFlow = JSON.parse(
    localStorage.getItem("selectedAbhaCard_mobileVerificationFLow"),
  );
  const mobile = JSON.parse(localStorage.getItem("mobile"));
  const [showFull, setShowFull] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [abhaProfile, setAbhaProfile] = useState(null);
  const [showProfileModal, setShowProfileModal] = useState(false);

  const [updatePayload, setUpdatePayload] = useState(null);
  const [creating, setCreating] = useState(false);
  const dispatch = useDispatch();

  let userInfo;
  if (cardSelectedInMobileFlow && userData?.accounts?.length > 0) {
    userInfo = userData?.accounts.filter((item) =>
      item.ABHANumber.split("-").includes(
        cardSelectedInMobileFlow.ABHANumber.split("-")[3],
      ),
    )[0];
  } else if (!cardSelectedInMobileFlow && userData?.accounts?.length > 0) {
    userInfo = userData?.accounts[0];
  } else if (userData?.users?.length > 0) {
    userInfo = userData?.users;
  } else {
    userInfo = userData;
  }

  const downloadabha = async () => {
    try {
      const storedToken = localStorage.getItem("downloadToken");
      console.log("storedToken", storedToken);
      const finalToken = storedToken;

      if (!finalToken) {
        console.error("No xToken available!");
        return;
      }

      setXToken(finalToken);

      const body = { xToken: finalToken };

      const response =
        downloadFlowToken === true
          ? await abhaCartDownloadServices({ body })
          : await abhaCartDownloadServicesVerification({ body });
      console.log("response---------", response, "####");

      if (response.status) {
        setAbhacarddata(response.result);
        setAbhaProfile(response.abhaProfile || {});
        setShowProfileModal(true);
        const patientData = JSON.parse(localStorage.getItem("selectedIndex"));
        const { yearOfBirth, monthOfBirth, dayOfBirth, gender } =
          response.abhaProfile || {};
        console.log("ABHA Profile Data:", {
          yearOfBirth,
          monthOfBirth,
          dayOfBirth,
          gender,
        });

        const dob = userInfo?.dob ? new Date(userInfo?.dob) : "";

        const yyyy = dob ? dob.getFullYear() : yearOfBirth;
        const mm = dob
          ? String(dob.getMonth() + 1).padStart(2, "0")
          : monthOfBirth;
        const dd = dob ? String(dob.getDate()).padStart(2, "0") : dayOfBirth;
        const formattedDob = `${yyyy}-${mm}-${dd}`;
        console.log(
          "formattedDob",
          formattedDob,
          yearOfBirth,
          monthOfBirth,
          dayOfBirth,
          "==+",
        );

        const updateBody = {
          patientId: patientData?.pId,
          abhaAddress: userInfo?.abhaAddress || userInfo?.preferredAbhaAddress,
          healthIdNumber: userInfo?.abhaNumber || userInfo?.ABHANumber,
          abhaDOB: userInfo?.dob
            ? formattedDob
            : userInfo?.age
              ? userInfo?.age
              : "" || userInfo?.abhaDOB || formattedDob,
          abhaGender: userInfo?.gender || gender === "M" ? "Male" : "Female",
          abhaName: userInfo?.firstName
            ? userInfo?.firstName +
              " " +
              userInfo?.middleName +
              " " +
              userInfo?.lastName
            : userInfo?.fullName
              ? userInfo?.fullName
              : "" || userInfo?.name,
          abhaCard: response?.result,
          fname: userInfo?.firstName || userInfo?.fullName,
          mname: userInfo?.middleName || "",
          lname: userInfo?.lastName,
          dob: formattedDob || userInfo?.dob || "",
          gender: userInfo?.gender || gender === "M" ? "Male" : "Female",
          fullname: userInfo?.firstName
            ? userInfo?.firstName +
              " " +
              userInfo?.middleName +
              " " +
              userInfo?.lastName
            : userInfo?.fullName
              ? userInfo?.fullName
              : userInfo?.name,
          abhaNumber: userInfo?.abhaNumber || userInfo?.ABHANumber,
          abhaAddress: userInfo?.abhaAddress || userInfo?.preferredAbhaAddress,
          mobile: userInfo?.mobile || mobile,
          _hasPatientId: !!(patientData && patientData?.pId),
        };

        setUpdatePayload(updateBody);
      } else {
        console.error("No card data in response", response);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };

  const handleCreate = async () => {
    if (!updatePayload) return;
    try {
      setCreating(true);
      const { _hasPatientId, ...body } = updatePayload;
      let responsed;
      if (_hasPatientId) {
        responsed = await UpdateAbhaUserServices({ body });
      } else {
        responsed = await createAbhaUserServices({ body });
      }
      if (responsed?.status) {
        localStorage.clear();
        setShowProfileModal(false);
      }
    } catch (error) {
      console.error("Error saving ABHA user:", error);
    } finally {
      setCreating(false);
    }
  };

  const handleDownload = (e) => {
    e.preventDefault();
    if (!abhacarddata) {
      toast.error("No card data available to download.");
      return;
    }
    const link = document.createElement("a");
    link.href = `data:image/png;base64,${abhacarddata}`;
    link.download = "abha-card.png";
    link.click();
    window.location.reload();
  };

  useEffect(() => {
    if (abhacarddata) {
      const imgUrl = `data:image/png;base64,${abhacarddata}`;
      setImageUrl(imgUrl);
      setLoading(false);
    }
  }, [abhacarddata]);

  useEffect(() => {
    downloadabha();
  }, []);

  // ── Returns ONLY the right-side card panel ──
  // (Title + Steps are already rendered by the parent component)
  return (
    <>
      <div
        className="lmop-card-wrap"
        style={{
          backgroundImage: `url(${formBgImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="lmop-card-inner">
          <h3 className="lmop-card-title">ABHA created successfully!</h3>

          <div className="p-3 text-center">
            {loading ? (
              <div className="shimmer-card"></div>
            ) : (
              <img
                src={imageUrl}
                className="abha-card-download"
                alt="ABHA Card"
                onClick={() => setShowFull(true)}
                style={{
                  cursor: "pointer",
                  maxWidth: "100%",
                  borderRadius: "10px",
                }}
              />
            )}
          </div>

          <button
            type="button"
            className="lmop-continue-btn"
            onClick={handleDownload}
          >
            DOWNLOAD YOUR ABHA CARD NOW
          </button>

          {inputType !== "abhaaddress" && (
            <>
              <h6 style={{ textAlign: "center", marginTop: 10 }}>OR</h6>
              <button
                type="button"
                className="lmop-continue-btn mt-2"
                onClick={() => dispatch(setGlobalCurrentStep("changeMobile"))}
              >
                Change Contact
              </button>
            </>
          )}

          <div className="lmop-nha-row">
            <span className="lmop-nha-label">Approved by NHA</span>
            <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
          </div>
        </div>
      </div>

      {/* ── Full Image Modal ── */}
      {showFull && (
        <div className="image-modal">
          <span className="close-btn2" onClick={() => setShowFull(false)}>
            &times;
          </span>
          <img src={imageUrl} className="modal-content" alt="ABHA Card Full" />
        </div>
      )}

      {/* ── ABHA Profile Info Modal ── */}
      {showProfileModal &&
        (() => {
          const p = abhaProfile || {};
          const aadharUser =
            JSON.parse(localStorage.getItem("aadhaarVerfiUser")) || {};
          const genderRaw = p.gender || userInfo?.gender || aadharUser?.gender;
          const genderLabel =
            genderRaw === "M"
              ? "Male"
              : genderRaw === "F"
                ? "Female"
                : genderRaw || "-";

          const nameFromProfile = [p.firstName, p.middleName, p.lastName]
            .filter(Boolean)
            .join(" ");
          const nameFromUser = [
            userInfo?.firstName,
            userInfo?.middleName,
            userInfo?.lastName,
          ]
            .filter(Boolean)
            .join(" ");
          const nameFromAadhar = [
            aadharUser?.firstName,
            aadharUser?.middleName,
            aadharUser?.lastName,
          ]
            .filter(Boolean)
            .join(" ");

          const dobFromProfile =
            p.yearOfBirth && p.monthOfBirth && p.dayOfBirth
              ? `${p.yearOfBirth}-${String(p.monthOfBirth).padStart(2, "0")}-${String(p.dayOfBirth).padStart(2, "0")}`
              : p.dob || "";

          const rows = [
            {
              label: "ABHA Number",
              value:
                p.ABHANumber ||
                p.healthIdNumber ||
                p.abhaNumber ||
                userInfo?.ABHANumber ||
                userInfo?.abhaNumber ||
                userInfo?.healthIdNumber ||
                aadharUser?.abhaNumber ||
                "-",
            },
            {
              label: "Name",
              value:
                nameFromProfile ||
                p.name ||
                p.fullName ||
                nameFromUser ||
                userInfo?.fullName ||
                userInfo?.name ||
                nameFromAadhar ||
                "-",
            },
            {
              label: "DOB",
              value:
                dobFromProfile ||
                userInfo?.dob ||
                aadharUser?.dob ||
                aadharUser?.abhaDOB ||
                "-",
            },
            {
              label: "Mobile",
              value: p.mobile || userInfo?.mobile || aadharUser?.mobile || "-",
            },
            { label: "Email", value: p.email || userInfo?.email || "-" },
            { label: "Gender", value: genderLabel },
            { label: "Address", value: p.address || userInfo?.address || "-" },
            {
              label: "State",
              value: p.stateName || userInfo?.stateName || "-",
            },
            {
              label: "District",
              value: p.districtName || userInfo?.districtName || "-",
            },
            {
              label: "Block",
              value:
                p.subDistrictName ||
                p.blockName ||
                userInfo?.subDistrictName ||
                "-",
            },
            {
              label: "Village/Town",
              value:
                p.villageName || p.townName || userInfo?.villageName || "-",
            },
            { label: "Pincode", value: p.pincode || userInfo?.pincode || "-" },
            {
              label: "ABHA Address",
              value:
                p.preferredAbhaAddress ||
                p.abhaAddress ||
                userInfo?.preferredAbhaAddress ||
                userInfo?.abhaAddress ||
                aadharUser?.abhaAddress ||
                "-",
            },
          ];

          return (
            <div
              className="abha-profile-modal-overlay"
              onClick={() => setShowProfileModal(false)}
            >
              <div
                className="abha-profile-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  className="abha-profile-close-btn"
                  onClick={() => setShowProfileModal(false)}
                >
                  &times;
                </button>
                <h4 className="abha-profile-modal-title">
                  ABHA Profile Details
                </h4>
                <div className="abha-profile-table">
                  {rows.map((row) => (
                    <div className="abha-profile-row" key={row.label}>
                      <span className="abha-profile-label">{row.label}:</span>
                      <span className="abha-profile-value">{row.value}</span>
                    </div>
                  ))}
                </div>
                <div className="abha-profile-btn-row">
                  <button
                    className="abha-profile-skip-btn"
                    onClick={() => setShowProfileModal(false)}
                    disabled={creating}
                  >
                    Skip
                  </button>
                  <button
                    className="abha-profile-create-btn"
                    onClick={() => {
                      handleCreate();
                      setShowProfileModal(false);
                    }}
                    disabled={creating}
                  >
                    {creating ? "Creating..." : "Create"}
                  </button>
                </div>
              </div>
            </div>
          );
        })()}
    </>
  );
};

export default AbhaCardUI;
